import { Directive, ElementRef, HostListener, Input } from '@angular/core';

@Directive({
  selector: '[appOnlyNumber]'
})
export class OnlyNumberDirective {
  @Input('onlyNumberMaxLength') maxLength = 4;

  constructor(private el: ElementRef<HTMLInputElement>) {
  }

  /** Verhindert Tastendrücke, die nicht 0–9 sind oder das Limit überschreiten */
  @HostListener('keypress', ['$event'])
  onKeyPress(event: KeyboardEvent) {
    const input = event.target as HTMLInputElement;
    const key = event.key;
    const current = input.value ?? '';

    // Erlaube Steuerzeichen (Backspace, Pfeiltasten etc.)
    if (event.ctrlKey || event.metaKey || key.length > 1) {
      return;
    }

    // Wenn kein Digit oder schon zu lang, blocken
    if (!/^[0-9]$/.test(key) || current.length >= this.maxLength) {
      event.preventDefault();
    }
  }

  /** Verhindert Paste von nicht-numerischen Zeichen oder Überlänge */
  @HostListener('paste', ['$event'])
  onPaste(event: ClipboardEvent) {
    const paste = event.clipboardData?.getData('text') ?? '';
    const filtered = paste.replace(/\D/g, '');               // nur digits
    const input = this.el.nativeElement;
    const value = input.value ?? '';
    const selStart = input.selectionStart ?? value.length;
    const selEnd = input.selectionEnd ?? selStart;

    // Neuer Inhalt, wenn eingefügt:
    const newValue =
      value.slice(0, selStart) +
      filtered +
      value.slice(selEnd);

    // Wenn gefilterter Text leer ist oder neue Länge zu groß => blocken
    if (!filtered || newValue.length > this.maxLength) {
      event.preventDefault();
    }
  }
}
